// Styles
import styles from './CustomVueSection.module.css';

/**
 * CustomVueSectionTitle
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueSectionTitle component
 */
function CustomVueSectionTitle({ children }) {
  return <div className={styles.title}>{children}</div>;
}

/**
 * CustomVueSectionContent
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueSectionContent component
 */
function CustomVueSectionContent({ children }) {
  return <div className={styles.content}>{children}</div>;
}

/**
 * CustomVueSectionFooter
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueSectionFooter component
 */
function CustomVueSectionFooter({ children }) {
  return <div className={styles.footer}>{children}</div>;
}

/**
 * CustomVueSectionTitleActions
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {JSX.Element} CustomVueSectionTitleActions component
 */
function CustomVueSectionTitleActions({ children }) {
  return <div className={styles['title-actions']}>{children}</div>;
}

export {
  CustomVueSectionTitle,
  CustomVueSectionContent,
  CustomVueSectionTitleActions,
  CustomVueSectionFooter,
};
